module.exports = __webpack_public_path__ + "img/_enterprise.4decbcea.svg";